routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    // .state('home.productDetail', {
    //   url: "/categories",
    //   template: `<product-detail sh-ctrl="shCtrl"></product-detail>`
    // })

    .state('home.productDetailSlug', {
      url: __env.routes.productDetailSlug,
      template: `<product-detail sh-ctrl="shCtrl"></product-detail>`,
      params: {
        productSlug: null
      }
    })
    .state('home.productDetailId', {
      url: __env.routes.productDetailId,
      template: `<product-detail sh-ctrl="shCtrl"></product-detail>`,
      params: {
        productId: null
      }
    });

}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/product-detail/product-detail.config.js
 **/